import type { IconType } from 'react-icons';
import { FiUser, FiUsers, FiHeart } from 'react-icons/fi';
import { FamilyRelationshipEnum } from '../../../../../../Types/Enums/HereditaryRelationshipEnum';

export const getRelationshipIcon = (relationship: FamilyRelationshipEnum | string): IconType => {
  switch (relationship) {
    case FamilyRelationshipEnum.MOTHER:
    case FamilyRelationshipEnum.FATHER:
    case FamilyRelationshipEnum.MATERNAL_GRANDMOTHER:
    case FamilyRelationshipEnum.PATERNAL_GRANDMOTHER:
    case FamilyRelationshipEnum.MATERNAL_GRANDFATHER:
    case FamilyRelationshipEnum.PATERNAL_GRANDFATHER:
      return FiUser;
    case FamilyRelationshipEnum.BROTHER:
    case FamilyRelationshipEnum.SISTER:
    case FamilyRelationshipEnum.MATERNAL_AUNT:
    case FamilyRelationshipEnum.PATERNAL_AUNT:
    case FamilyRelationshipEnum.MATERNAL_UNCLE:
    case FamilyRelationshipEnum.PATERNAL_UNCLE:
      return FiUsers;
    default:
      return FiHeart;
  }
};

export const getLineageBadgeInfo = (relationship: FamilyRelationshipEnum | string) => {
  const maternalRelations: string[] = [
    FamilyRelationshipEnum.MOTHER,
    FamilyRelationshipEnum.MATERNAL_GRANDMOTHER,
    FamilyRelationshipEnum.MATERNAL_GRANDFATHER,
    FamilyRelationshipEnum.MATERNAL_AUNT,
    FamilyRelationshipEnum.MATERNAL_UNCLE,
  ];

  const paternalRelations: string[] = [
    FamilyRelationshipEnum.FATHER,
    FamilyRelationshipEnum.PATERNAL_GRANDMOTHER,
    FamilyRelationshipEnum.PATERNAL_GRANDFATHER,
    FamilyRelationshipEnum.PATERNAL_AUNT,
    FamilyRelationshipEnum.PATERNAL_UNCLE,
  ];

  if (maternalRelations.includes(relationship)) {
    return { labelEs: 'Línea Materna', labelEn: 'Maternal Line', variant: 'info' };
  }
  if (paternalRelations.includes(relationship)) {
    return { labelEs: 'Línea Paterna', labelEn: 'Paternal Line', variant: 'primary' };
  }
  return { labelEs: 'Hermanos / Directo', labelEn: 'Siblings / Direct', variant: 'secondary' };
};